// components/BottomModal.tsx
'use client';

import { useEffect, useState } from 'react';

interface BottomModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

export default function BottomModal({ isOpen, onClose, children }: BottomModalProps) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIsVisible(true);
            document.body.style.overflow = 'hidden';
        } else {
            setIsVisible(false);
            const timer = setTimeout(() => {
                document.body.style.overflow = 'unset';
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) onClose();
    };

    if (!isOpen && !isVisible) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
                className="fixed inset-0 bg-black transition-opacity duration-300"
                style={{
                    opacity: isVisible ? 0.5 : 0,
                    transition: 'opacity 300ms ease-in-out'
                }}
                onClick={handleOverlayClick}
            />

            <div
                className="relative bg-white rounded-2xl shadow-lg max-h-[90vh] overflow-hidden"
                style={{
                    opacity: isVisible ? 1 : 0,
                    transform: isVisible ? 'scale(1)' : 'scale(0.95)',
                    transition: 'opacity 300ms ease-in-out, transform 300ms ease-in-out'
                }}
            >
                <div className="overflow-y-auto max-h-[90vh]">
                    {children}
                </div>
            </div>
        </div>
    );
}